<!-- template v.1 -->
<template>
<div class="col py-3">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Copiar Regla Marcación </h4>
    
            </div>
             <div class="col-md-12" style="padding:0;margin-bottom:15px">
                <div class="card card-info">
                    <div class="card-header">
                        <h3 class="card-title">Datos</h3>
                        
                    </div>
                <div class="card-body" style="padding-top:0px">
                    <div class="col-md-12">
                    <div class="col-md-4 form-org">
                        <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Nombre
                            </label>
                            <input type="text" class="form-control" maxlength="50" v-model="Nombre" placeholder="Nombre" required >
                        </div>
                        <div class="form-group ">
                            <div class="col-md-12">
                            <div class="col-md-10" style="float:left">
                            <label class="col-form-label"  >Tipos</label>
                            
                            <select class="form-control"    v-model="Tipos" style="width: 95%;">
                                <option value="-1" >Seleccione </option>
                                <option v-for="item in ListaTipos" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                
                            </select>
                            </div>
                            <div class="col-md-2" style="float:right">
                            <label class="col-form-label" v-if="Tipos == 2"  >Rpta.</label>
                             <select class="form-control"   v-model="Rpta2" v-if="Tipos == 2" >
                            
                            <option value="1" >Si</option>
                            <option value="2" >No</option>
                            
                            </select>
                            <label class="col-form-label" v-if="Tipos == 1"  >Min.</label>
                            <input type="number" class="form-control" @keypress="MaxNumber($event)"  min="1" max="120"  v-model="Rpta" placeholder="XXX" v-if="Tipos == 1"  >
                            </div>
                            </div>
                            </div>
                    </div>
                    </div>
                    <div class="col-md-12">
                        <div class="col-md-4 form-org" style="padding: 0px 20px;">  
                        <label class="col-form-label"  style="width: 100%;padding-bottom: 7px;">
                            Aplica a
                        </label>
                        <div class="form-check">
                        <input class="form-check-input" type="radio" id="todos" name="radiobutton" @change="EventTodos()" value="1" >
                        <label class="form-check-label" for="todos">Todos</label>
                        </div>

                        <div class="form-check">
                        <input class="form-check-input" type="radio" id="local" name="radiobutton" value="2" @change="EventLocal()" >
                        <label class="form-check-label" for="local">Local</label>
                        </div>

                        <div class="form-check">
                        <input class="form-check-input" type="radio" id="area" name="radiobutton" value="3" @change="EventArea()">
                        <label class="form-check-label" for="area">Área</label>
                        </div>
                        </div>
                    
                        <div class="col-md-4 form-org">
                        <div class="form-group ">
                            <label class="col-form-label" >Local</label>
                            <select class="form-control"    v-model="Local"  id="ComboLocal" disabled>
                            <option value="-1" >Seleccione </option>
                            <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                            
                            </select>
                        </div>
                        <div class="form-group ">
                            <label class="col-form-label" > Área</label>
                            <select class="form-control"   v-model="Area" id="ComboArea" disabled>
                            <option value="-1"  >Seleccione </option>
                            <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                            
                            </select>
                           
                        </div>
                    </div>
                     </div>
                    
                </div>
        </div>
    </div>
    
    
        <div class="col-md-12" >
            <button type="button" class="btn btn-success guardar-modal" @click="Guardar()" >Guardar</button>
        <router-link to="/reglas-marcacion"><button type="button" class="btn btn-danger cancelar-modal" > Cancelar</button></router-link>
        </div>
        </div>

    
    <div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      Locales:[],
      Areas:[],
      ListaTipos:[],
      Tipos:-1,
      Local:-1,
      Area:-1,
      Rpta: "",
      Rpta2: -1,

      Nombre:"",
      
       
    };
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    if(this.$route.query.regla == 1){
    this.Tipos = this.$route.query.regla;
    this.Rpta = this.$route.query.valor; 
 
    }
    else{
    this.Tipos = this.$route.query.regla;
    this.Rpta2 = this.$route.query.valor;   
    }
    if(this.$route.query.aplicar == 1){
    document.getElementById("todos").checked = true;
    document.getElementById('ComboArea').disabled = true;
    document.getElementById('ComboLocal').disabled = true;
    this.Local = -1;
    this.Area = -1;  
    }
    else if (this.$route.query.aplicar == 2) {
    document.getElementById("local").checked = true;
    document.getElementById('ComboArea').disabled = true;
    document.getElementById('ComboLocal').disabled = false;
    this.Local = this.$route.query.hijo;
    this.Area = -1; 
    }
    else {
    document.getElementById("area").checked = true;
    document.getElementById('ComboLocal').disabled = true;
    document.getElementById('ComboArea').disabled = false;
    this.Area = this.$route.query.hijo;
    this.Local = -1;    
    }
    let gestion = this.$store.state.menu;
   
    this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })
    
    this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=24", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.ListaTipos = response.data.oListaParametros;
        })
  },

 
  methods: {
    EventLocal(){
    document.getElementById('ComboArea').disabled = true;
    document.getElementById('ComboLocal').disabled = false;
    this.Area = -1;
    },
    EventArea(){
    document.getElementById('ComboArea').disabled = false;
    document.getElementById('ComboLocal').disabled = true;
    this.Local = -1;
    },
    EventTodos(){
    document.getElementById('ComboArea').disabled = true;
    document.getElementById('ComboLocal').disabled = true;
    this.Local = -1;
    this.Area = -1;
    },
    Guardar(){
        if(this.Nombre == ""){
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe escribir un nombre a la regla',
            icon: 'error',
            
            }); 
            return;  
        }
        if(document.getElementById("todos").checked){
        var nombre = this.Nombre;
        var aplicar = 1;
        var hijo = 0;
        var regla = this.Tipos;
        if(this.Tipos == 2){
        var valor = this.Rpta2;
        }
        else if (this.Tipos == 1){
            if(this.Rpta == ""){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe llenar todo los campos',
            icon: 'error',
            
            }); 
            return;
            }
            else if(this.Rpta > 120){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'tiempo límite de 120 minutos',
            icon: 'error',
            
            }); 
            return;
            }
            else {
            var valor = this.Rpta;
            }
        }
        else {
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe seleccionar un Tipo',
            icon: 'error',
            
            }); 
            return;
        }
        }
        if(document.getElementById("local").checked){
        var nombre = this.Nombre;
        var aplicar = 2;
        
        var regla = this.Tipos;
        if(this.Local == -1){
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe seleccionar un local',
            icon: 'error',
            
            }); 
            return;
        }
        else{
        var hijo = this.Local;
        }
        if(this.Tipos == 2){
        var valor = this.Rpta2;
        }
        else if (this.Tipos == 1){
            if(this.Rpta == ""){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe llenar todo los campos',
            icon: 'error',
            
            }); 
            return;
            }
            else if(this.Rpta > 120){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'tiempo límite de 120 minutos',
            icon: 'error',
            
            }); 
            return;
            }
            else {
            var valor = this.Rpta;
            }
        }
        else {
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe seleccionar un Tipo',
            icon: 'error',
            
            }); 
            return;
        }
        }
        if(document.getElementById("area").checked){
        var nombre = this.Nombre;
        var aplicar = 2;
        
        var regla = this.Tipos;
        if(this.Area == -1){
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe seleccionar un área',
            icon: 'error',
            
            }); 
            return;
        }
        else{
        var hijo = this.Area;
        }
        if(this.Tipos == 2){
        var valor = this.Rpta2;
        }
        else if (this.Tipos == 1){
            if(this.Rpta == ""){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe llenar todo los campos',
            icon: 'error',
            
            }); 
            return;
            }
            else if(this.Rpta > 120){
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'tiempo límite de 120 minutos',
            icon: 'error',
            
            }); 
            return;
            }
            else {
            var valor = this.Rpta;
            }
        }
        else {
        this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: 'Debe seleccionar un Tipo',
            icon: 'error',
            
            }); 
            return;
        }
        }
        let gestion = this.$store.state.menu;
        var bodyFormData = new FormData();
        bodyFormData.append("sNombre", nombre);
        bodyFormData.append("nIdAplicarA", aplicar);
        bodyFormData.append("nIdHijo", hijo);
        bodyFormData.append("nIdTipoRegla", regla);
        bodyFormData.append("nValor", valor);
        this.axios.post(gestion + "/NuevaRegla", bodyFormData, {
            headers: {
                Authorization: "Bearer " + localStorage.token,
                "Content-Type": "multipart/form-data",
            }
            })
            .then((response) => {
            const data_res = response.data.satisfactorio;
            this.load=false;
            if (data_res == true) { 
                //this.$store.state.message = true;
                this.$swal({
                    toast: true,
                    timer:3000,
                    position: 'top',
                    showConfirmButton: false,
                    title: 'Se proceso la acción con éxito.',
                    icon: 'success',
                
                });  
                this.$router.push("reglas-marcacion");
            }
            else{
            this.$swal({
            toast: true,
            timer:3000,
            position: 'top',
            showConfirmButton: false,
            title: response.data.message,
            icon: 'error',
            
            });  
            }
            
            });

    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 3 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Solo puede ingresar 3 dígitos.',
          icon: 'error',
          
          });
            evt.preventDefault();
          }
    }
}
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;
    font-size: 14px;
}
.form-check {
    padding-bottom: 15px;
}
</style>